import { TourismEvent } from '@/tourism-events/tourism-events.model';

export const DEFAULT_TOURISM_EVENT: TourismEvent = {
	id: null,
	newId: null,
	created: null,
	type: null,
	owner: null,
	organizationOwner: null,
	countries: null,
	name: null,
	date_from: null,
	date_to: null,
	date_prepare: null,
	datePrepareAuto: null,
	category: null,
	crew_count: null,
	status: null,
	planned_people_count: null,
	drivers_departure: [],
	drivers_program: [],
	drivers_return: [],
	drivers_senior: [],
	sumValue: null,
	tourist_guides_departure: [],
	tourist_guides_program: [],
	tourist_guides_return: [],
	tourist_guides_departure_periods: [],
	tourist_guides_program_periods: [],
	tourist_guides_return_periods: [],
	tasks: [],
	accommodation: null,
	text_departure: null,
	text_return: null,
	text_drivers: null,
	text_organization: null,
	text_program: null,
	text_client: null,
	text_refueling: null,
	text_billing: null,
	text_notes: null,
	program_date_from: null,
	program_date_to: null,
	program_start_driver_place: null,
	program_end_driver_place: null,
	briefingPlace: null,
	textBriefing: null,
	briefingUser: null,
	startPlace: null,
	startPlaceCity: null,
	startDate: null,
	endDate: null,
	endPlace: null,
	endPlaceCity: null,
	startPostCode: null,
	endPostCode: null,
	people: null,
	drivers: null,
	text_hotel: null,
	city_source: null,
	accommodation_detail: null,
	city_destination: null,
	// driver_informed: false,
	driver_informed_departure: false,
	driver_informed_return: false,
	departure_place_confirmed: false,
	return_place_confirmed: false,
	services_confirmed: false,
	ready_for_printing: false,
	was_printed: false,
	board: [],
	detail_about_first_day_confirmed: false,
	detail_about_program_confirmed: false,
	detail_about_last_day_confirmed: false,
	services: false,
	board_confirmed: false,
	night_confirmed: false,
	night: [],
	is_virtual_driver: 0,
	text_opinion: null,
	date_deadline: null,
	dateDeadlineAuto: null,
	people_confirmed: null,
	client_wishes: null,
	client_representative: null,
	guide_informed: false,
	guide_informed_return: false,
	client_informed: false,
	text_guide: null,
	place_return: null,
	invoiceRequired: true,
	invoiceRequiredNote: null,
	agreement_signature: null,
	agreement_value: null,
	agreement_value_currency: 'PLN',
	agreement_value_pln: null,
	predicted_profit: 0,
	predicted_profit_currency: 'PLN',
	predicted_profit_pln: null,
	agreement_mileage_limit: null,
	calculation_link: null,
	errorsCount: null,
	leadSource: null,
	note: null,
	client: null,
	clientEvent: null,
	reconciliation_comments: '',
	reconciliation_type: 0,
	vehicles: [],
};
